import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import CartItem from './CartItem';

export default function DeliverySection({
  delivery,
  products,
  isMobile,
  first,
  currency,
  nav,
  emptyProducts,
  onChangeQuantity,
  onRemove,
}) {
  if (!products.length) return null;

  return (
    <>
      <Grid
        container
        justifyContent="space-between"
        style={{
          width: isMobile ? '95%' : '75%',
          borderBottom: '1px solid #000000',
          paddingBottom: 11,
          marginTop: first ? 44 : 80,
        }}
      >
        <Grid>
          {delivery && (
            <>
              <Typography
                display="inline"
                style={{ fontWeight: 'bold', fontSize: 16 }}
              >
                {`${delivery.title} `}
              </Typography>
              <Typography display="inline" style={{ fontSize: 16 }}>
                {delivery.subTitle1} | {delivery.subTitle2}
              </Typography>
            </>
          )}
        </Grid>
        <Grid>
          <Typography display="inline" style={{ fontSize: 14 }}>
            {products.length} styles added
          </Typography>
        </Grid>
      </Grid>
      <Grid>
        {products.map(product => (
          <Grid item key={product.style_code} style={{ marginBottom: 10 }}>
            <CartItem
              product={product}
              currency={currency}
              isMobile={isMobile}
              nav={nav}
              isEmpty={emptyProducts.includes(product.style_code)}
              onChangeQuantity={onChangeQuantity}
              onRemove={onRemove}
            />
          </Grid>
        ))}
      </Grid>
    </>
  );
}
